const getContentTypeName = (content_abbr: string) => {
  switch (content_abbr) {
    case 'SH':
      return 'Student Handout';
    case 'TG':
      return 'Teacher Guide';
    case 'CW':
      return 'Courseware';
    case 'EB':
      return 'Ebook';
    case 'ST':
      return 'Student Template';
    case 'A':
      return 'Assessments';
    case 'R':
      return 'Rubric';
    case 'drive':
      return 'Drive';
    default:
      return null;
  }
};

export default getContentTypeName;
